"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[281],{

/***/ 1281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3786);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4480);
/* harmony import */ var _table_PaymentWayTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1874);
/* harmony import */ var _hooks_common_useReset__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7822);
/* harmony import */ var _data_estimate_common_paymentWay_info_atom__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7689);
/* harmony import */ var _hooks_estimate_common_useActiveTab__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1846);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  gap: 8px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}








const Base = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), (props)=>props.isDisplay ? "flex" : "none");
/**
 *  지불방법 비교 테이블을 감싸는 컴포넌트
 *  */ function CompareTableAreaa() {
    // ref
    const baseRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    // tab
    const { id  } = (0,_hooks_estimate_common_useActiveTab__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    // reset
    (0,_hooks_common_useReset__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_data_estimate_common_paymentWay_info_atom__WEBPACK_IMPORTED_MODULE_7__/* .isCompareInfoState */ .Tc);
    // select
    const isCompareInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_4__/* .useRecoilValue */ .sJ)(_data_estimate_common_paymentWay_info_atom__WEBPACK_IMPORTED_MODULE_7__/* .isCompareInfoState */ .Tc);
    const isCompare = isCompareInfo[id - 1].info || false;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
    // const base: HTMLDivElement | null = baseRef.current;
    // if (base && isCompare) {
    //   // 비교추가가 클릭되었을 때 스크롤을 자연스럽게 비교추가 지불방법 테이블 위치로 오게 한다.
    //   const top: number = (base.offsetTop || 0) - 100;
    //   window.scroll({
    //     left: 0,
    //     top,
    //     behavior: 'smooth',
    //   });
    // }
    }, [
        isCompareInfo
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Base, {
        ref: baseRef,
        isDisplay: isCompare,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_table_PaymentWayTable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                tableNo: 2
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_table_PaymentWayTable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                tableNo: 3
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_table_PaymentWayTable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                tableNo: 4
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (CompareTableAreaa);


/***/ })

}]);